// extracted by mini-css-extract-plugin
export var logoDesktop = "indexContainer-module--logo-desktop--9bTzN";
export var logoMobile = "indexContainer-module--logo-mobile--nO2kf";
export var imageFrame = "indexContainer-module--image-frame--9okS-";
export var imageWrapper = "indexContainer-module--image-wrapper--XNI-W";
export var gatsbyImageWrapper = "indexContainer-module--gatsby-image-wrapper--v0w7f";
export var image = "indexContainer-module--image---28hX";